import React from 'react'
import {Trans} from '@lingui/macro'
import {useDispatch, useSelector} from 'react-redux'
import {getColor} from 'components/utils'
import {Alert} from 'components/UI/Alert/Alert'
import {IdHandoverRecordsState} from 'model/dashboardHandoverRecord/dHandoverRecordReducer'
import {dHRecordSetDetailItemAC} from 'model/dashboardHandoverRecord/dHandoverRecordActionCreators'
import { numberCurrencyFormat } from 'constants/convertToLocalCurrency';


// Type
export type typeTableHeader = {
    variant?: string
}

// Header data component
export const TableHeader: React.FC<typeTableHeader> = () => {


    return(
        <>
            <th scope="col" className="px-4 py-2 text-left text-xxs font-medium  uppercase tracking-wider">
                <Trans>Store name</Trans> / <Trans>POS number</Trans>
            </th>
            <th scope="col" className="px-4 py-2 text-left text-xxs font-medium  uppercase tracking-wider">
                <Trans>Starting date</Trans> / <Trans>Closing date</Trans>
            </th>

            <th scope="col" className="px-4 py-2 text-left text-xxs font-medium  uppercase tracking-wider">
                <Trans>Cashier</Trans>
            </th>

            <th scope="col" className="divide-y px-4 py-2 text-xxs font-medium  uppercase tracking-wider text-center">
                <Trans>Count of sales</Trans> / <Trans>Amount of sales</Trans>
            </th>
            <th scope="col" className="px-4 py-2  text-xxs font-medium  uppercase tracking-wider text-center">
                <Trans>Cash payment</Trans> / <Trans>Card payment</Trans> / <Trans>Cashless payment</Trans>
            </th>
            <th scope="col" className="px-4 py-2 text-xxs font-medium  uppercase tracking-wider text-center">
                <Trans>Count of refund</Trans> / <Trans>Amount of refund</Trans>
            </th>
            <th scope="col" className="px-4 py-2  text-xxs font-medium  uppercase tracking-wider text-center">
                <Trans>Cash refund</Trans> / <Trans>Card refund</Trans> / <Trans>Cashless refund</Trans>
            </th>

        </>
    )
}

export type typeTableBody = {
    variant?: string
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>
}


// Body data component
export const TableBody: React.FC<typeTableBody> = ({variant, setOpenPopupDetails}) => {

    const color = getColor(variant)
    const dispatch = useDispatch();

    const tableData = useSelector((state: {dHRecord:IdHandoverRecordsState}) =>
    state.dHRecord.data)

    let component

    const handleClick = (id: string) => {
        dispatch(dHRecordSetDetailItemAC(id))
        setOpenPopupDetails(true)
    }


    if (tableData.length) {
        component = tableData.map((item, index) => {
            const openDate = item.openDate!==null ? item.openDate.substring(0, 19).replace('T', ' , ') : '-'
            const closeDate = item.closeDate !==null ? item.closeDate.substring(0, 19).replace('T', ' , ') : '-'

            return(
                <tr key={item.id} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-${color}-50`} onClick={() => handleClick(item.id)}>

                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500 cursor-pointer">
                        <div className="flex flex-col divide-y">
                            <span className="font-medium text-left text-xs pb-1">{!!item.pos?.store ? item.pos.store.name : '-'}</span>
                            <span className="text-xs text-left pt-1">{item.pos?.posNumber? item.pos?.posNumber : '-'}</span>
                        </div>
                    </td>

                    <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 cursor-pointer">
                        <div className="flex flex-col divide-y">
                            <span className="font-medium text-left text-xs pb-1">{openDate}</span>
                            <span className="text-xs text-left pt-1">{closeDate}</span>
                        </div>
                    </td>

                    <td className="px-4 py-2 text-sm text-gray-500  cursor-pointer">
                        <div className="flex flex-col divide-y">
                            <span className="font-medium text-left text-xs pb-1">{`${item.cashierName? item.cashierName: '-'}`}</span>
                        </div>
                    </td>

                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500  cursor-pointer">
                        <div className="flex flex-col divide-y">
                            <span className="font-medium text-center text-xs pb-1">{item.salesCount ? item.salesCount : '' }</span>
                            <span className="font-medium text-center text-xs pt-1">{item.salesAmount && numberCurrencyFormat(item.salesAmount)}</span>
                        </div>
                    </td>

                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500 cursor-pointer">
                        <div className="flex flex-col divide-y">
                            <span className="font-medium text-center text-xs pb-1">{item.salesWithCash && numberCurrencyFormat(item.salesWithCash)}</span>
                            <span className="font-medium text-center text-xs pt-1">{item.salesWithCards && numberCurrencyFormat(item.salesWithCards)}</span>
                            <span className="font-medium text-center text-xs pt-1">{item.salesWithCashless && numberCurrencyFormat(item.salesWithCashless)}</span>
                        </div>
                    </td>

                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500 cursor-pointer">
                        <div className="flex flex-col divide-y">
                            <span className="font-medium text-center text-xs pb-1">{item.refundsCount? item.refundsCount : '-'}</span>
                            <span className="font-medium text-center text-xs pt-1">{item.refundsAmount && numberCurrencyFormat(item.refundsAmount)}</span>
                        </div>
                    </td>

                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500 cursor-pointer">
                        <div className="flex flex-col divide-y">
                            <span className="font-medium text-center text-xs pb-1">{item.refundsWithCash && numberCurrencyFormat(item.refundsWithCash)}</span>
                            <span className="font-medium text-center text-xs pt-1">{item.refundsWithCards && numberCurrencyFormat(item.refundsWithCards)}</span>
                            <span className="font-medium text-center text-xs pt-1">{item.refundsWithCashless && numberCurrencyFormat(item.refundsWithCashless)}</span>
                        </div>
                    </td>

                </tr>
            )
        })
    } else {
        component = <tr>
            <td className="p-2" colSpan={7}>
                <Alert className="w-full" type={"info"} title={<Trans>The handover records list is empty. Check filters</Trans>}/>
            </td>
        </tr>
    }

    return(
        <>
            {component}
        </>
    )
}
